// src/components/FacebookPixel.jsx
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const FacebookPixel = () => {
  const globalData = useSelector((state) => state.globalData.globalDataName);
  const pixelId = globalData?.metaPixelId;

  useEffect(() => {
    // If Pixel ID is missing, log a warning and return early
    if (!pixelId) {
      console.warn('Facebook Pixel ID is missing!');
      return;
    }

    // Check if fbq is already initialized
    if (window.fbq) {
      // If fbq is already initialized, track the page view
      window.fbq('track', 'PageView');
      return;  // Skip the script loading if fbq is already available
    }

    // Facebook Pixel base code to load the script
    (function(f, b, e, v, n, t, s) {
      n = f.fbq = function() {
        n.callMethod ? n.callMethod(...arguments) : n.queue.push(arguments);
      };
      n.queue = [];
      n.version = '2.0'; // Version of the Facebook Pixel
      n.loaded = true;
      t = b.createElement(e);
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'; // Facebook Pixel script URL
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script');

    // After the script is loaded, initialize and track page view
    window.fbq('init', pixelId);  // Initialize Facebook Pixel with the Pixel ID
    window.fbq('track', 'PageView'); // Track page view event
  }, [pixelId]); // Dependency array ensures the effect runs only when pixelId changes

  return null; // This component doesn't render anything to the DOM
};

export default FacebookPixel;

